import _, { isObject } from "lodash";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  MTFavoriteFiltersListName,
  myTasks5WayDependListName,
  myTasks5WayStatusesListName,
  myTasksDepartmentsListName,
  myTasksDeviationReportDependListName,
  myTasksDeviationReportKpiByTriggerListName,
  myTasksDeviationReportTriggersListName,
  myTasksKpiByTriggerListName,
  myTasksKPIListName,
  myTasksLocationsListName,
  myTasksRegionsListName,
  myTasksTriggersListName,
} from "src/api/config/myTasksLists.config";
import Form from "src/components/Form";
import Loading from "src/components/Loading";
import { SearchUI } from "src/components/ui/Search";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { getItemsRequest } from "src/modules/spItems/api";
import { selectItems } from "src/modules/spItems/selectors";
import { addUsers } from "src/modules/users/actions";
import { selectCurrentUser } from "src/modules/users/selector";
import { RootState } from "src/store/rootReducer";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import Add5Way from "../add5Way/add5Way.mobile";
import { myTasks5WayWithRelationsListName, myTasks5WayItemsPerPage } from "src/api/config/myTasks5Way.config";
import MyTasksList5WayTable from "src/components/tables/MyTasksList5WayTable.mobile";
import LoadingOpBg from "src/components/LoadingOpBg";
import { FiveWhyType } from "src/api/config/systemSwitch";
import FilterActions from "src/components/filter-actions/filter-actions.mobile";
import FiltersButton from "src/components/filters-button/filters-button";

function List5WayFilters({
  setFilters,
  setSearchQuery,
  setGetList5Way,
  setLocalFilters,
  type,
  setDisplayFilters,
  filtersParams,
  setFiltersParams,
  defaultUserFilter,
  userFilterCheck,
  reRenderUserFilter,
  resetFilters,
  setResetFiters,
  list5WayFilter,
  setList5WayFilter,
  onResetFilters
}: any) {
  const [defaultValues, setDefaultValues] = useState({});
  const [fields, setFields] = useState<any>([
    {
      type: "dateRange",
      require: false,
      key: "Date5Way",
      title: "Дата",
      isFilter: true,
      placeholder: "дд.мм.гггг",
      width: "w-full",
    },
    {
      type: "checkbox",
      require: false,
      key: "Status",
      isFilter: true,
      title: "Статус",
      width: "w-full",
    },
    {
      type: "checkbox",
      require: false,
      key: "Location",
      isFilter: true,
      searchInFilterCheckbox: true,
      title: "Локация",
      width: "w-full",
    },
    {
      type: "checkbox",
      require: false,
      key: "Department",
      searchInFilterCheckbox: true,
      isFilter: true,
      title: "Отдел",
      width: "w-full",
    },
    {
      type: "checkbox",
      require: false,
      key: "Region",
      searchInFilterCheckbox: true,
      title: "Участок",
      isFilter: true,
      placeholder: "Не выбрано",
      width: "w-full",
    },
    {
      type: "checkbox",
      require: false,
      key: "Trigger",
      searchInFilterCheckbox: true,
      isFilter: true,
      title: (type === FiveWhyType && "Триггер 5Почему") || "Триггер",
      placeholder: "Не выбрано",
      width: "w-full",
    },
    {
      type: "checkbox",
      require: false,
      key: "KPI",
      searchInFilterCheckbox: true,
      title: "KPI",
      isFilter: true,
      placeholder: "Не выбрано",
      width: "w-full",
    },
    {
      type: "peoplePicker",
      require: false,
      single: true,
      isFilter: true,
      key: "AuthorEmail",
      title: "Автор",
      current: false,
      placeholder: "Введите имя или фамилию",
      width: "w-full",
    },
    {
      type: "peoplePicker",
      require: false,
      single: true,
      isFilter: true,
      key: "Editors",
      title: (type === FiveWhyType && "Ответственный") || "Участник",
      current: false,
      placeholder: "Введите имя или фамилию",
      width: "w-full",
    },
    {
      type: "radio",
      require: false,
      isFilter: true,
      key: "ProblemRepeat",
      title: "Повторяющаяся проблема?",
      width: "w-full",
    },
    {
      type: "radio",
      require: true,
      isFilter: true,
      key: "Tree",
      title: "Корневая причина выявлена",
      width: "w-full",
    },
    {
      type: "radio",
      require: true,
      isFilter: true,
      key: "ActionsPlan",
      title: "Действия запланированы",
      width: "w-full",
    },
  ]);
  // const [list5WayFilter, setList5WayFilter] = useState<any>(null);

  const [dependenceFields, setDependenceFields] = useState<any>({
    Location: null,
    Department: null,
    Region: null,
    Trigger: null,
    KPI: null,
  });
  const currentUser = useAppSelector((state) => selectCurrentUser(state));

  const statuses: any = useAppSelector((state) =>
    selectItems(state, myTasks5WayStatusesListName)
  );
  const locations: any = useAppSelector((state) =>
    selectItems(state, myTasksLocationsListName)
  );
  const departments: any = useAppSelector((state) =>
    selectItems(state, myTasksDepartmentsListName)
  );
  const regions: any = useAppSelector((state) =>
    selectItems(state, myTasksRegionsListName)
  );
  const triggers: any = useAppSelector((state) =>
    selectItems(state, myTasksTriggersListName)
  );
  const triggersDeviationReport: any = useAppSelector((state) =>
    selectItems(state, myTasksDeviationReportTriggersListName)
  );
  const kpiItems: any = useAppSelector((state) =>
    selectItems(state, myTasksKPIListName)
  );

  const dispatch = useAppDispatch();
  const [customLoading, setCustomLoading] = useState(true);
  // const [resetFilters, setResetFiters] = useState(false);
  const [isDefaultDepartment, setDefaultDepartment] = useState(0);

  //Формируем данные фильтры по умолчанию
  useEffect(() => {
    setCustomLoading(true);
    const tempFieldsForm = [...fields];
    let tempTriggers: any = [];
    if (type === FiveWhyType) {
      tempTriggers = [...triggers];
    } else {
      tempTriggers = [...triggersDeviationReport];
    }
    for (let i = 0; i < tempFieldsForm.length; i++) {
      if (tempFieldsForm[i]["key"] === "Status") {
        tempFieldsForm[i]["optionsInputs"] = statuses.map((status: any) => {
          return {
            id: status.ID,
            name: status.Title,
            disabled: false,
          };
        });
      }
      if (tempFieldsForm[i]["key"] === "Location") {
        tempFieldsForm[i]["optionsInputs"] = locations.map((location: any) => {
          return {
            id: location.ID,
            name: location.Title,
            disabled: false,
          };
        });
      }
      if (tempFieldsForm[i]["key"] === "Department") {
        tempFieldsForm[i]["optionsInputs"] = departments.map(
          (department: any) => {
            return {
              id: department.ID,
              name: department.Title,
              disabled: false,
            };
          }
        );
      }
      if (tempFieldsForm[i]["key"] === "Region") {
        tempFieldsForm[i]["optionsInputs"] = regions.map((region: any) => {
          return {
            id: region.ID,
            name: region.Title,
            disabled: false,
          };
        });
      }
      if (tempFieldsForm[i]["key"] === "Trigger") {
        tempFieldsForm[i]["optionsInputs"] = tempTriggers.map(
          (trigger: any) => {
            return {
              id: trigger.ID,
              name: trigger.Title,
              disabled: false,
            };
          }
        );
      }
      if (tempFieldsForm[i]["key"] === "KPI") {
        tempFieldsForm[i]["optionsInputs"] = kpiItems.map((kpiItem: any) => {
          return {
            id: kpiItem.ID,
            name: kpiItem.Title,
            disabled: false,
          };
        });
      }
      if (tempFieldsForm[i]["key"] === "ProblemRepeat") {
        tempFieldsForm[i]["optionsInputs"] = ["Да", "Нет"];
      }
      if (tempFieldsForm[i]["key"] === "Tree") {
        tempFieldsForm[i]["optionsInputs"] = ["Да", "Нет"];
      }
      if (tempFieldsForm[i]["key"] === "ActionsPlan") {
        tempFieldsForm[i]["optionsInputs"] = ["Да", "Нет"];
      }
    }
    setFields([...tempFieldsForm]);
    setCustomLoading(false);
  }, [
    locations,
    statuses,
    departments,
    regions,
    triggers,
    kpiItems,
    triggersDeviationReport,
    type,
  ]);

  useEffect(() => {
      if (Object.keys(currentUser).length > 0 && currentUser.id > 0 && (triggers.length > 0 || triggersDeviationReport.length > 0)) {
        setCustomLoading(true);
        let filtersDepend5Way: any = {};
        let filtersDependKpi: any = {};
        const tempFieldsForm = [...fields];
        let tempTriggers: any = [];
        if (type === FiveWhyType) {
          tempTriggers = [...triggers];
        } else {
          tempTriggers = [...triggersDeviationReport];
        }
        Object.keys(dependenceFields).map((key) => {
          for (let i = 0; i < tempFieldsForm.length; i++) {
            if (tempFieldsForm[i]["key"] === key) {
              tempFieldsForm[i]["optionsInputs"] = tempFieldsForm[i][
                "optionsInputs"
              ].map((option: any) => {
                return {
                  id: option.id,
                  name: option.name,
                  disabled: false,
                };
              });
            }
          }
        });
        Object.keys(dependenceFields).map((key) => {
          if (
            dependenceFields[key] &&
            dependenceFields[key].length > 0 &&
            key !== "KPI"
          ) {
            if (key === "Department") {
              filtersDepend5Way["Departament"] = dependenceFields[key].map(
                (item: any) => item.id
              );
            } else {
              filtersDepend5Way[key] = dependenceFields[key].map(
                (item: any) => item.id
              );
            }
          } else if (
            key === "KPI" &&
            dependenceFields[key] &&
            dependenceFields[key].length > 0
          ) {
            filtersDependKpi["Kpi"] = dependenceFields[key].map(
              (item: any) => item.id
            );
          }
        });
        if (
          Object.keys(filtersDependKpi).length === 0 &&
          Object.keys(filtersDepend5Way).length === 0
        ) {
          setFields([...tempFieldsForm]);
          setCustomLoading(false);
        } else {
          if (
            Object.keys(filtersDependKpi).length > 0 &&
            Object.keys(filtersDepend5Way).length === 0
          ) {
            getItemsRequest({
              listName:
                (type === FiveWhyType && myTasksKpiByTriggerListName) ||
                myTasksDeviationReportKpiByTriggerListName,
              filters: filtersDependKpi,
              method: type === FiveWhyType && '/api/kpi-by-triggers/search' || '/api/deviation-report-kpi-by-triggers/search'
            }).then((results) => {
              const dependKpiByTrigger = [...results.items];
              const triggerIds = _.uniqWith(
                dependKpiByTrigger
                  .filter((item: any) => item.Trigger)
                  .map((item: any) => item.Trigger.get_lookupId()),
                _.isEqual
              );
              for (let i = 0; i < tempFieldsForm.length; i++) {
                if (tempFieldsForm[i]["key"] === "Trigger") {
                  tempFieldsForm[i]["optionsInputs"] = tempTriggers.map(
                    (trigger: any) => {
                      return {
                        id: trigger.ID,
                        name: trigger.Title,
                        disabled: false, //triggerIds.indexOf(trigger.ID) === -1,
                        hide: triggerIds.indexOf(trigger.ID) === -1
                      };
                    }
                  );
                }
              }
              setFields([...tempFieldsForm]);
              setCustomLoading(false);
            });
          }
          if (Object.keys(filtersDepend5Way).length > 0) {
            //Устанавливаем зависимости в фильтрах
            getItemsRequest({
              listName:
                (type === FiveWhyType && myTasks5WayDependListName) ||
                myTasksDeviationReportDependListName,
              filters: filtersDepend5Way,
              filtersType: "or",
            }).then((results) => {
              const depend5Way = [...results.items];
              const locationIds = _.uniqWith(
                depend5Way.map((item: any) => item.Location.get_lookupId()),
                _.isEqual
              );
              const departmentIds = _.uniqWith(
                depend5Way.map((item: any) => item.Departament.get_lookupId()),
                _.isEqual
              );
              const regionIds = _.uniqWith(
                depend5Way.map((item: any) => item.Region.get_lookupId()),
                _.isEqual
              );
              const filterMap = {
                Location: "Location",
                Departament: "Departament",
                Region: "Region",
              };
              const triggerIds = Object.values(
                _.groupBy(
                  depend5Way.filter(item => item.Trigger && !item.Hide),
                  item => item.Trigger.get_lookupId()
                )
              ).filter(items =>
                Object.entries(filterMap).every(([filterKey, field]) => {
                  const values = filtersDepend5Way[filterKey];

                  if (!values?.length) return true;

                  return items.some((item: any) =>
                    values.includes(item[field]?.get_lookupId())
                  );
                })
              ).map(items => items[0].Trigger.get_lookupId());
              for (let i = 0; i < tempFieldsForm.length; i++) {
                if (tempFieldsForm[i]["key"] === "Location") {
                  if (
                    !filtersDepend5Way["Location"] ||
                    Object.keys(filtersDepend5Way).length > 1
                  ) {
                    tempFieldsForm[i]["optionsInputs"] = locations.map(
                      (location: any) => {
                        return {
                          id: location.ID,
                          name: location.Title,
                          disabled: false, //locationIds.indexOf(location.ID) === -1,
                          hide: locationIds.indexOf(location.ID) === -1,
                        };
                      }
                    );
                  }
                }
                if (tempFieldsForm[i]["key"] === "Department") {
                  if (
                    !filtersDepend5Way["Departament"] ||
                    Object.keys(filtersDepend5Way).length > 1
                  ) {
                    tempFieldsForm[i]["optionsInputs"] = departments.map(
                      (department: any) => {
                        return {
                          id: department.ID,
                          name: department.Title,
                          disabled: false, //departmentIds.indexOf(department.ID) === -1,
                          hide: departmentIds.indexOf(department.ID) === -1,
                          user_Department: department.User_Department
                        };
                      }
                    );
                    tempFieldsForm[i]["optionsInputs"].forEach((department: any) => {
                      if (department.user_Department && department.user_Department.indexOf(currentUser.department) !== -1 && department.disabled) {
                        setDefaultDepartment(department.id);
                      }
                    });
                  }
                }
                if (tempFieldsForm[i]["key"] === "Region") {
                  if (
                    !filtersDepend5Way["Region"] ||
                    Object.keys(filtersDepend5Way).length > 1
                  ) {
                    tempFieldsForm[i]["optionsInputs"] = regions.map(
                      (region: any) => {
                        return {
                          id: region.ID,
                          name: region.Title,
                          disabled: false, //regionIds.indexOf(region.ID) === -1,
                          hide: regionIds.indexOf(region.ID) === -1,
                        };
                      }
                    );
                  }
                }
                if (tempFieldsForm[i]["key"] === "Trigger") {
                  if (
                    !filtersDepend5Way["Trigger"] ||
                    Object.keys(filtersDepend5Way).length > 1
                  ) {
                    tempFieldsForm[i]["optionsInputs"] = tempTriggers.filter((trigger: any) => triggerIds.includes(trigger.ID)).map(
                      (trigger: any) => {
                        return {
                          id: trigger.ID,
                          name: trigger.Title,
                          disabled: false, //triggerIds.indexOf(trigger.ID) === -1,
                          hide: triggerIds.indexOf(trigger.ID) === -1,
                        };
                      }
                    );
                  }
                }
              }
              if (triggerIds.length > 0) {
                getItemsRequest({
                  listName:
                    (type === FiveWhyType && myTasksKpiByTriggerListName) ||
                    myTasksDeviationReportKpiByTriggerListName,
                  filters: { Trigger: triggerIds },
                  method: type === FiveWhyType && '/api/kpi-by-triggers/search' || '/api/deviation-report-kpi-by-triggers/search'
                }).then((results) => {
                  const dependKpiByTrigger = [...results.items];
                  const kpiIds = _.uniqWith(
                    dependKpiByTrigger.map((item: any) => item.Kpi.get_lookupId()),
                    _.isEqual
                  );
                  for (let i = 0; i < tempFieldsForm.length; i++) {
                    if (tempFieldsForm[i]["key"] === "KPI") {
                      tempFieldsForm[i]["optionsInputs"] = kpiItems.map(
                        (kpiItem: any) => {
                          return {
                            id: kpiItem.ID,
                            name: kpiItem.Title,
                            disabled: false, //kpiIds.indexOf(kpiItem.ID) === -1,
                            hide: kpiIds.indexOf(kpiItem.ID) === -1,
                          };
                        }
                      );
                    }
                  }
                  setFields([...tempFieldsForm]);
                  setCustomLoading(false);
                });
              } else {
                setFields([...tempFieldsForm]);
                setCustomLoading(false);
              }
            });
          }
        }
      }
    }, [dependenceFields, currentUser, triggers, triggersDeviationReport]);

  useEffect(() => {
    if (locations.length > 0 && Object.keys(currentUser).length > 0 && currentUser.id > 0 && departments.length > 0) {
      let defaultObj: any = {};
      const today = moment();
      const isMonday = today.isoWeekday() === 1;
      if (Object.keys(filtersParams).length > 0) {
        Object.keys(filtersParams).forEach(key => {
          if (filtersParams[key]) {
            defaultObj[key] = filtersParams[key];
          } else {
            defaultObj[key] = null;
          }
        });
        defaultObj['Date5Way'] = filtersParams['Date5Way'] || (!defaultUserFilter && list5WayFilter && list5WayFilter['Date5Way']) || {
          startDate: isMonday && moment().subtract(1, "weeks").startOf("week").format('YYYY-MM-DDT00:00:00') || moment().startOf("week").format('YYYY-MM-DDT00:00:00'),
          endDate: isMonday && moment().subtract(1, "weeks").endOf("week").format('YYYY-MM-DDT23:59:59') || moment().endOf("week").format('YYYY-MM-DDT23:59:59')
        };
        if (!_.isEqual(defaultValues, defaultObj)) {
          setDefaultValues(defaultObj);
        }
      } else if (defaultUserFilter && Object.keys(JSON.parse(defaultUserFilter.MTFullFilters)).length > 0) {
        const parsedDefault = JSON.parse(defaultUserFilter.MTFullFilters);
        Object.keys(parsedDefault).forEach(key => {
          if (parsedDefault[key]) {
            defaultObj[key] = parsedDefault[key];
          } else {
            defaultObj[key] = null;
          }
        });
        defaultObj['Date5Way'] = parsedDefault['Date5Way'] || {
          startDate: isMonday && moment().subtract(1, "weeks").startOf("week").format('YYYY-MM-DDT00:00:00') || moment().startOf("week").format('YYYY-MM-DDT00:00:00'),
          endDate: isMonday && moment().subtract(1, "weeks").endOf("week").format('YYYY-MM-DDT23:59:59') || moment().endOf("week").format('YYYY-MM-DDT23:59:59')
        };
        if (!_.isEqual(defaultValues, defaultObj)) {
          setDefaultValues(defaultObj);
        }
      } else {
        let defaultLocationsIds: number[] = [];
        if (currentUser.isLocationAdminMyTasks || currentUser.isLocationEditorMyTasks) {
          if (Array.isArray(currentUser.isLocationAdminMyTasks) && currentUser.isLocationAdminMyTasks.length > 0) {
            defaultLocationsIds = [...defaultLocationsIds, ...currentUser.isLocationAdminMyTasks];
          }
          if (Array.isArray(currentUser.isLocationEditorMyTasks) && currentUser.isLocationEditorMyTasks.length > 0) {
            defaultLocationsIds = [...defaultLocationsIds, ...currentUser.isLocationEditorMyTasks];
          }
        }
        let unicDefaultLocationsIds: number[] = [..._.uniqWith(defaultLocationsIds, _.isEqual)];
        setDependenceFields({
          Location: unicDefaultLocationsIds.length > 0 && unicDefaultLocationsIds.map(id => {
            return { id: id, name: locations.find((collection: any) => collection.ID === id)['Title'], disabled: false }
          }) || null,
          Department: null,
          Region: null,
          Trigger: null,
          KPI: null,
        });
        fields.map((field: any) => {
          if (field.key === "Date5Way") {
            defaultObj[field.key] = (list5WayFilter && list5WayFilter[field.key]) || {
              startDate: isMonday && moment().subtract(1, "weeks").startOf("week").format('YYYY-MM-DDT00:00:00') || moment().startOf("isoWeek").format('YYYY-MM-DDT00:00:00'),
              endDate: isMonday && moment().subtract(1, "weeks").endOf("week").format('YYYY-MM-DDT23:59:59') || moment().endOf("isoWeek").format('YYYY-MM-DDT23:59:59')
            };
          } else if (field.key === "Location") {
            defaultObj[field.key] = unicDefaultLocationsIds.length > 0 && unicDefaultLocationsIds.map(id => {
              return { id: id, name: locations.find((collection: any) => collection.ID === id)['Title'], disabled: false }
            }) || null;
          } else if (field.key === "Department") {
            defaultObj[field.key] = departments.filter((department: any) => currentUser.department && department.User_Department && department.User_Department.indexOf(currentUser.department) !== -1).map((department: any) => {
              return { id: department.ID, name: department.Title, disabled: false }
            }) || null;
          } else {
            defaultObj[field.key] = null;
          }
        });
        setDefaultValues(defaultObj);
      }
    }
  }, [resetFilters, locations, JSON.stringify(currentUser), reRenderUserFilter, departments]);

  useEffect(() => {
    if (list5WayFilter && Object.keys(list5WayFilter).length > 0) {
      const existsFilters5Way: any = {};
      Object.keys(list5WayFilter).map((key) => {
        if (list5WayFilter[key]) {
          if (Array.isArray(list5WayFilter[key])) {
            if (list5WayFilter[key].length > 0) {
              existsFilters5Way[key] = list5WayFilter[key];
            }
          } else if (isObject(list5WayFilter[key])) {
            if (Object.keys(list5WayFilter[key]).length > 0) {
              existsFilters5Way[key] = list5WayFilter[key];
            }
          } else {
            existsFilters5Way[key] = list5WayFilter[key];
          }
        }
      });
      const tempFilters: any = {};
      const tempDisplayFilters: any = {};
      let temp5WayLocalFilter: any = [];

      Object.keys(existsFilters5Way).map((key) => {
        if (key === "Date5Way") {
          if (
            moment(existsFilters5Way[key].startDate).isValid() &&
            moment(existsFilters5Way[key].endDate).isValid()
          ) {
            tempFilters[key] = {
              start: moment(existsFilters5Way[key].startDate).startOf('day').format('YYYY-MM-DDT00:00:00'),
              end: moment(existsFilters5Way[key].endDate).endOf('day').format('YYYY-MM-DDT23:59:59'),
            };
            tempDisplayFilters[key] = `от ${moment(existsFilters5Way[key].startDate).format('DD.MM.YYYY')} до ${moment(existsFilters5Way[key].endDate).format('DD.MM.YYYY')}`;
          }
        } else if (
          key === "Location" ||
          key === "Department" ||
          key === "Region" ||
          key === "Status" ||
          key === "Trigger" ||
          key === "KPI"
        ) {
          tempFilters[key] = existsFilters5Way[key].map((item: any) => item.id);
          tempDisplayFilters[key] = existsFilters5Way[key].map((item: any) => item.name);
        } else if (key === "AuthorEmail" || key === "Editors") {
          tempFilters[key] = `${existsFilters5Way[key][0]["value"]}*`;
          tempDisplayFilters[key] = existsFilters5Way[key][0]["label"];
          if (type === FiveWhyType && key === "Editors") {
            temp5WayLocalFilter = [
              ...temp5WayLocalFilter,
              { responsible: existsFilters5Way[key][0]["value"] },
            ];
          }
        } else if (key === "Tree") {
          temp5WayLocalFilter = [
            ...temp5WayLocalFilter,
            { tree: existsFilters5Way[key] },
          ];
          tempDisplayFilters[key] = existsFilters5Way[key];
        } else if (key === "ProblemRepeat") {
          if (existsFilters5Way[key] === "Да") {
            tempFilters[key] = true;
          } else {
            tempFilters[key] = false;
          }
          tempDisplayFilters[key] = existsFilters5Way[key];
        } else if (key === "ActionsPlan") {
          temp5WayLocalFilter = [
            ...temp5WayLocalFilter,
            { actionsPlan: existsFilters5Way[key] },
          ];
          tempDisplayFilters[key] = existsFilters5Way[key];
        } else {
          tempFilters[key] = existsFilters5Way[key];
          tempDisplayFilters[key] = existsFilters5Way[key];
        }
      });
      setLocalFilters(temp5WayLocalFilter);
      setFilters((prev: any) => {
        const merged = { ...prev, ...tempFilters };
        const hasChanges = !_.isEqual(prev, merged);
        if (hasChanges) {
          return merged;
        }
        return prev;
      });
      setDisplayFilters((prev: any) => {
        const merged = { ...prev, ...tempDisplayFilters };
        const hasChanges = !_.isEqual(prev, merged);
        if (hasChanges) {
          return merged;
        }
        return prev;
      });
      const tempExistsFilters5Why = { ...existsFilters5Way };
      if (!_.isEqual(filtersParams, tempExistsFilters5Why)) {
        setFiltersParams({ ...tempExistsFilters5Why });
      }
      setGetList5Way(false);
    } else {
      setSearchQuery("");
    }
  }, [list5WayFilter]);

  useEffect(() => {
    console.log('isDefaultDepartment: ', isDefaultDepartment);
    if (isDefaultDepartment) {
      setDefaultValues((prevState) => {
        return { ...prevState, Department: null }
      });
    }
  }, [isDefaultDepartment]);

  return (
    <FlexCol className="relative filters-date-no-remove">
      {customLoading && <LoadingOpBg />}
      <Form
        key={`${reRenderUserFilter ?? 0}-${JSON.stringify(defaultValues)}`}
        type="list5way_filters_my_tasks"
        setFormData={setList5WayFilter}
        fieldsForm={fields}
        defaultValues={defaultValues}
        setDependenceFields={setDependenceFields}
      />
      {list5WayFilter && Object.keys(list5WayFilter).length > 0 && (
        <div
          onClick={onResetFilters}
          className="p-5 flex flex-row group items-center text-[12px] text-[#637381] cursor-pointer gap-x-2 flex-nowrap"
        >
          <div className="flex flex-col group-hover:underline">
            Сбросить фильтры
          </div>
          <div className="flex flex-col pt-1">
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_33_4954)">
                <path
                  d="M5.9998 5.39995L1.4248 0.824951C1.25605 0.656201 0.993555 0.656201 0.824805 0.824951C0.656055 0.993701 0.656055 1.2562 0.824805 1.42495L5.3998 5.99995L0.824805 10.575C0.656055 10.7437 0.656055 11.0062 0.824805 11.175C0.993555 11.3437 1.25605 11.3437 1.4248 11.175L5.9998 6.59995L10.5748 11.175C10.7436 11.3437 11.0061 11.3437 11.1748 11.175C11.2498 11.1 11.3061 10.9875 11.3061 10.875C11.3061 10.7625 11.2686 10.65 11.1748 10.575L6.5998 5.99995L11.1748 1.42495C11.2498 1.34995 11.3061 1.23745 11.3061 1.12495C11.3061 1.01245 11.2686 0.899951 11.1748 0.824951C11.0061 0.656201 10.7436 0.656201 10.5748 0.824951L5.9998 5.39995Z"
                  fill="#637381"
                ></path>
              </g>
              <defs>
                <clipPath id="clip0_33_4954">
                  <rect
                    width="12"
                    height="12"
                    fill="white"
                    transform="translate(0 12) rotate(-90)"
                  ></rect>
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
      )}
    </FlexCol>
  );
}

export function List5Way({ type }: { type: string }) {
  const [exportData, setExportData] = useState<any>({});
  const [filters, setFilters] = useState<any>({});
  const [localFilters, setLocalFilters] = useState<any>([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [nextPage, setNextPage] = useState<any>(null);
  const [list5Way, setList5Way] = useState<any>([]);
  const [tempList5Way, setTempList5Way] = useState<any>([]);
  const dispatch = useAppDispatch();
  const [customLoading, setCustomLoading] = useState(true);
  const [getList5Way, setGetList5Way] = useState(false);
  const location = useLocation();
  const statusUsers: string = useAppSelector(
    (state: RootState) => state.users.status
  );
  const currentUser = useAppSelector((state) => selectCurrentUser(state));

  function handleSearch(value: string) {
    setSearchQuery(value);
  }

  const [displayFilters, setDisplayFilters] = useState<any>({});
  const [displayFiltersStr, setDisplayFiltersStr] = useState<any>("");
  const [reRenderFilterSettings, setReRenderFilterSettings] = useState(false);
  const [filtersParams, setFiltersParams] = useState({});
  const [defaultUserFilter, setDefaultUserFilter] = useState<any>(null);
  const [userFilterCheck, setUserFilterCheck] = useState(false);
  const [reRenderUserFilter, setReRenderUserFilter] = useState(null);

  const [isOpenFilter, setIsOpenFilter] = useState(false);
  const [resetFilters, setResetFiters] = useState(false);
  const [list5WayFilter, setList5WayFilter] = useState<any>(null);
  const locations: any = useAppSelector((state) => selectItems(state, myTasksLocationsListName));
  const [favoriteFilters, setFavoriteFilters] = useState<any[]>([]);
  const [favoriteFiltersDone, setFavoriteFiltersDone] = useState<boolean>(false);

  const isSelectedFilters = useMemo(() => {
        return (
            (filters.Status && filters.Status.length > 0) ||
            (filters.Location && filters.Location.length > 0) ||
            (filters.Department && filters.Department.length > 0) ||
            (filters.Region && filters.Region.length > 0) ||
            (filters.Trigger && filters.Trigger.length > 0) ||
            (filters.KPI && filters.KPI.length > 0) ||
            (filters.AuthorEmail && filters.AuthorEmail.trim() !== '') ||
            (filters.Editors && filters.Editors.trim() !== '') ||
            (filters.Tree && filters.Tree !== '') ||
            (filters.ActionsPlan && filters.ActionsPlan !== '') ||
            (filters.ProblemRepeat === true) ||
            (filters.Type5Way && filters.Type5Way !== '')
        )
    }, [filters]);

  const resetFiltersHandler = () => {
    const defaultFiltersFavorite = favoriteFilters.find((item: any) => item.DefaultFilter === true);
    setDefaultUserFilter(defaultFiltersFavorite || null);
    setFilters({});
    setLocalFilters([]);
    setList5WayFilter(null);
    setDisplayFilters({});
    setFiltersParams({});
    setResetFiters(!resetFilters);
    setGetList5Way(false);
  }

  // Эффект для начальной загрузки избранных фильтров
  useEffect(() => {
    if (!currentUser?.id) return;
    if (favoriteFiltersDone) return;

    getItemsRequest({
      listName: MTFavoriteFiltersListName,
      filters: { Author: currentUser.id, Type: "fiveWhy" },
      rowLimit: myTasks5WayItemsPerPage,
    }).then(results => {
      setFavoriteFilters([...results.items]);
      setFavoriteFiltersDone(true);
    })
  }, [currentUser]);

useEffect(() => {
  if (!locations.length || !currentUser?.id) return;
  if (!favoriteFiltersDone && favoriteFilters.length === 0) return;
  if (Object.keys(filters).length > 0) return;

  const today = moment();
  const isMonday = today.isoWeekday() === 1;

  const defaultLocationIds = [
    ...(Array.isArray(currentUser.isLocationAdminMyTasks)
      ? currentUser.isLocationAdminMyTasks
      : []),
    ...(Array.isArray(currentUser.isLocationEditorMyTasks)
      ? currentUser.isLocationEditorMyTasks
      : []),
  ];

  const uniqueLocationIds = _.uniq(defaultLocationIds);

  const defaultFilters = {
    Date5Way: {
      start: isMonday
        ? moment().subtract(1, "week").startOf("isoWeek").format("YYYY-MM-DDT00:00:00")
        : moment().startOf("isoWeek").format("YYYY-MM-DDT00:00:00"),
      end: isMonday
        ? moment().subtract(1, "week").endOf("isoWeek").format("YYYY-MM-DDT23:59:59")
        : moment().endOf("isoWeek").format("YYYY-MM-DDT23:59:59"),
    },
    ...(uniqueLocationIds.length > 0 && {
      Location: uniqueLocationIds,
    }),
  };

  const defaultFiltersFavorite = favoriteFilters.find((item: any) => item.DefaultFilter === true);

  let finalFilters;

  if (defaultFiltersFavorite) {
    const parsedFavorite = JSON.parse(defaultFiltersFavorite.MTFilters);
    finalFilters = { ...defaultFilters, ...parsedFavorite };
  } else {
    finalFilters = defaultFilters;
  }

  setFilters(finalFilters);
  setGetList5Way(false);

}, [currentUser, locations, favoriteFiltersDone, favoriteFilters]);

  useEffect(() => {
    const controller = new AbortController();
    let canceled = false;
    if (!getList5Way && Object.keys(filters).length > 0) {
      filters["Type5Way"] = type;
      setCustomLoading(true);
      setTempList5Way([]);
      setList5Way([]);
      getItemsRequest({
        listName: myTasks5WayWithRelationsListName,
        rowLimit: myTasks5WayItemsPerPage,
        filters,
        sortOrder: { name: "ID", desc: true },
        signal: controller.signal,
      })
        .then((results: any) => {
          if (canceled) return;
          const { items, nextPage } = results;
          let emails: any = [];
          items.map((item: any) => {
            item.Editors &&
              item.Editors.split(";").map((email: string) => {
                emails = [...emails, email];
              });
          });
          if (nextPage) {
            setNextPage(nextPage);
          } else {
            setNextPage(false);
          }
          dispatch(addUsers([..._.uniqWith(emails, _.isEqual)]));
          setTempList5Way([...items]);
          setGetList5Way(true);
        })
        .catch((err) => {
          if (canceled || err.name === 'AbortError' || err.name === 'CanceledError') return;
          console.error(err);
        });
    }
    return () => {
      canceled = true;
      controller.abort();
    };
  }, [filters]);

  //Получение 5Почему по nextPage
  useEffect(() => {
    if (nextPage && getList5Way) {
      getItemsRequest({
        listName: myTasks5WayWithRelationsListName,
        rowLimit: myTasks5WayItemsPerPage,
        filters,
        nextPage,
        sortOrder: { name: "ID", desc: true },
      }).then((results: any) => {
        const { items, nextPage } = results;
        let emails: any = [];
        items.map((item: any) => {
          item.Editors &&
            item.Editors.split(";").map((email: string) => {
              emails = [...emails, email];
            });
        });

        dispatch(addUsers([..._.uniqWith(emails, _.isEqual)]));
        setTempList5Way((prevState: any) => [...prevState, ...items]);
        if (nextPage) {
          setNextPage(nextPage);
        } else {
          setNextPage(false);
        }
      });
    }
  }, [nextPage]);

  //Локальная фильтрация
  useEffect(() => {
    if (localFilters.length > 0) {
      let tempLocalData: any = [...tempList5Way];

      let responsible = null,
        tree = null,
        actionsPlan = null;
      if (
        localFilters.find((item: any) => item.hasOwnProperty("responsible"))
      ) {
        responsible = localFilters.find((item: any) =>
          item.hasOwnProperty("responsible")
        )["responsible"];
      }
      if (localFilters.find((item: any) => item.hasOwnProperty("tree"))) {
        tree = localFilters.find((item: any) => item.hasOwnProperty("tree"))[
          "tree"
        ];
      }
      if (
        localFilters.find((item: any) => item.hasOwnProperty("actionsPlan"))
      ) {
        actionsPlan = localFilters.find((item: any) =>
          item.hasOwnProperty("actionsPlan")
        )["actionsPlan"];
      }
      if (responsible) {
        tempLocalData = tempLocalData.filter(
          (item: any) =>
            item.Editors &&
            item.Editors.split(";")[item.Editors.split(";").length - 1] ===
            responsible
        );
        if (tree) {
          if (tree === "Да") {
            tempLocalData = tempLocalData.filter(
              (item: any) =>
                item.Tree && (item.Tree.indexOf(`"root":true`) !== -1 || item.Tree.indexOf(`"system":true`))
            );
          } else {
            tempLocalData = tempLocalData.filter(
              (item: any) =>
                !item.Tree ||
                (item.Tree && (item.Tree.indexOf(`"root":true`) === -1 || item.Tree.indexOf(`"system":true`)))
            );
          }
          if (actionsPlan) {
            if (actionsPlan === "Да") {
              tempLocalData = tempLocalData.filter(
                (item: any) => item.actionsPlan
              );
            } else {
              tempLocalData = tempLocalData.filter(
                (item: any) => !item.actionsPlan
              );
            }
          }
        }
        if (actionsPlan) {
          if (actionsPlan === "Да") {
            tempLocalData = tempLocalData.filter(
              (item: any) => item.actionsPlan
            );
          } else {
            tempLocalData = tempLocalData.filter(
              (item: any) => !item.actionsPlan
            );
          }
          if (tree) {
            if (tree === "Да") {
              tempLocalData = tempLocalData.filter(
                (item: any) =>
                  item.Tree && (item.Tree.indexOf(`"root":true`) !== -1 || item.Tree.indexOf(`"system":true`))
              );
            } else {
              tempLocalData = tempLocalData.filter(
                (item: any) =>
                  !item.Tree ||
                  (item.Tree && (item.Tree.indexOf(`"root":true`) === -1 || item.Tree.indexOf(`"system":true`)))
              );
            }
          }
        }
      }
      if (tree) {
        if (tree === "Да") {
          tempLocalData = tempLocalData.filter(
            (item: any) => item.Tree && (item.Tree.indexOf(`"root":true`) !== -1 || item.Tree.indexOf(`"system":true`))
          );
        } else {
          tempLocalData = tempLocalData.filter(
            (item: any) =>
              !item.Tree ||
              (item.Tree && (item.Tree.indexOf(`"root":true`) === -1 || item.Tree.indexOf(`"system":true`)))
          );
        }
        if (actionsPlan) {
          if (actionsPlan === "Да") {
            tempLocalData = tempLocalData.filter(
              (item: any) => item.actionsPlan
            );
          } else {
            tempLocalData = tempLocalData.filter(
              (item: any) => !item.actionsPlan
            );
          }
          if (responsible) {
            tempLocalData = tempLocalData.filter(
              (item: any) =>
                item.Editors &&
                item.Editors.split(";")[item.Editors.split(";").length - 1] ===
                responsible
            );
          }
        }
        if (responsible) {
          tempLocalData = tempLocalData.filter(
            (item: any) =>
              item.Editors &&
              item.Editors.split(";")[item.Editors.split(";").length - 1] ===
              responsible
          );

          if (actionsPlan) {
            if (actionsPlan === "Да") {
              tempLocalData = tempLocalData.filter(
                (item: any) => item.actionsPlan
              );
            } else {
              tempLocalData = tempLocalData.filter(
                (item: any) => !item.actionsPlan
              );
            }
          }
        }
      }
      if (actionsPlan) {
        if (actionsPlan === "Да") {
          tempLocalData = tempLocalData.filter((item: any) => item.actionsPlan);
        } else {
          tempLocalData = tempLocalData.filter(
            (item: any) => !item.actionsPlan
          );
        }

        if (tree) {
          if (tree === "Да") {
            tempLocalData = tempLocalData.filter(
              (item: any) =>
                item.Tree && (item.Tree.indexOf(`"root":true`) !== -1 || item.Tree.indexOf(`"system":true`))
            );
          } else {
            tempLocalData = tempLocalData.filter(
              (item: any) =>
                !item.Tree ||
                (item.Tree && (item.Tree.indexOf(`"root":true`) === -1 || item.Tree.indexOf(`"system":true`)))
            );
          }
          if (responsible) {
            tempLocalData = tempLocalData.filter(
              (item: any) =>
                item.Editors &&
                item.Editors.split(";")[item.Editors.split(";").length - 1] ===
                responsible
            );
          }
        }
        if (responsible) {
          tempLocalData = tempLocalData.filter(
            (item: any) =>
              item.Editors &&
              item.Editors.split(";")[item.Editors.split(";").length - 1] ===
              responsible
          );

          if (tree) {
            if (tree === "Да") {
              tempLocalData = tempLocalData.filter(
                (item: any) =>
                  item.Tree && (item.Tree.indexOf(`"root":true`) !== -1 || item.Tree.indexOf(`"system":true`))
              );
            } else {
              tempLocalData = tempLocalData.filter(
                (item: any) =>
                  !item.Tree ||
                  (item.Tree && (item.Tree.indexOf(`"root":true`) === -1 || item.Tree.indexOf(`"system":true`)))
              );
            }
          }
        }
      }
      if (searchQuery) {
        setList5Way([
          ..._.uniqWith(
            tempLocalData.filter(
              (item: any) =>
                item.Description.toLowerCase().indexOf(
                  searchQuery.toLowerCase()
                ) !== -1 ||
                item.Details.toLowerCase().indexOf(
                  searchQuery.toLowerCase()
                ) !== -1
            ),
            _.isEqual
          ),
        ]);
      } else {
        setList5Way([..._.uniqWith(tempLocalData, _.isEqual)]);
      }
    } else if (searchQuery) {
      const tempLocalData: any = [...tempList5Way];
      setList5Way([
        ..._.uniqWith(
          tempLocalData.filter(
            (item: any) =>
              item.Description.toLowerCase().indexOf(
                searchQuery.toLowerCase()
              ) !== -1 ||
              item.Details.toLowerCase().indexOf(searchQuery.toLowerCase()) !==
              -1
          ),
          _.isEqual
        ),
      ]);
    } else {
      setList5Way([..._.uniqWith(tempList5Way, _.isEqual)]);
    }
  }, [tempList5Way, localFilters, searchQuery]);

  useEffect(() => {
      const card5WayID =
        new URLSearchParams(location.search).get("5WayCardMobile") ||
        new URLSearchParams(location.search).get("deviationCardMobile");
      if (card5WayID && localStorage.getItem("NEW_5WAY")) {
        localStorage.setItem("NEW_5WAY", "");
        setGetList5Way(false);
      }
    }, [location]);

  useEffect(() => {
    if (!nextPage && getList5Way) {
      setCustomLoading(false);
    }
  }, [list5Way]);

  useEffect(() => {
    let tempStr = "";
    Object.keys(displayFilters).map((key: string, idx: number) => {
      if (idx <= 3) {
        if (Array.isArray(displayFilters[key])) {
          displayFilters[key].map((item: string, idx: number) => {
            if (displayFilters[key].length - 1 === idx) {
              tempStr += item
            } else {
              tempStr += `${item}, `
            }
          })
        } else {
          tempStr += `${displayFilters[key]}`
        }
        tempStr += ', '
      }
    });
    tempStr = tempStr.slice(0, -2);
    if (Object.keys(displayFilters).length > 4) {
      tempStr += `...ещё ${Object.keys(displayFilters).length - 4}`
    }
    setDisplayFiltersStr(tempStr);
  }, [displayFilters]);

  const extraCompareData = useMemo(() => {
    const today = moment();
    const isMonday = today.isoWeekday() === 1;
    const defaultDateRange = {
      startDate: isMonday
        ? moment().subtract(1, "weeks").startOf("isoWeek").format('YYYY-MM-DDT00:00:00')
        : moment().startOf("isoWeek").format('YYYY-MM-DDT00:00:00'),
      endDate: isMonday
        ? moment().subtract(1, "weeks").endOf("isoWeek").format('YYYY-MM-DDT23:59:59')
        : moment().endOf("isoWeek").format('YYYY-MM-DDT23:59:59'),
    };
    const result: any = {};
    if (list5WayFilter?.Date5Way && !_.isEqual(list5WayFilter.Date5Way, defaultDateRange)) {
      result.Date5Way = list5WayFilter.Date5Way;
    }
    return Object.keys(result).length > 0 ? result : undefined;
  }, [list5WayFilter]);

  return (
    <FlexRow className="scrollbar scrollbar-w-2 scrollbar-thumb-rounded-md scrollbar-thumb-[#D1D5DB] h-screen overflow-y-auto">
      <FlexCol className="bg-white sticky-custom border-r w-80 text-[14px] text-[#8899A8] relative scrollbar scrollbar-w-2 scrollbar-thumb-rounded-md scrollbar-thumb-[#D1D5DB] max-h-screen hidden">
        <FlexCol className="max-w-[320px] overflow-y-auto scrollbar scrollbar-w-2 scrollbar-thumb-rounded-md scrollbar-thumb-[#D1D5DB]">
          <FilterActions
              isOpen={isOpenFilter} onClose={() => setIsOpenFilter(false)}
              onResetFilters={() => resetFiltersHandler() }
              filters={filters}
              displayFilters={displayFilters}
              reRenderFilterSettings={reRenderFilterSettings}
              setReRenderFilterSettings={setReRenderFilterSettings}
              filtersParams={filtersParams}
              type={type}
              setGetList5Way={setGetList5Way}
              setFiltersParams={setFiltersParams}
              setDefaultUserFilter={setDefaultUserFilter}
              setUserFilterCheck={setUserFilterCheck}
              userFilterCheck={userFilterCheck}
              setReRenderUserFilter={setReRenderUserFilter}
              favoriteFilters={favoriteFilters}
              setFavoriteFilters={setFavoriteFilters}
              extraCompareData={extraCompareData}
          >
            <List5WayFilters
            setGetList5Way={setGetList5Way}
            setFilters={setFilters}
            setSearchQuery={setSearchQuery}
            setLocalFilters={setLocalFilters}
            searchQuery={searchQuery}
            type={type}
            setDisplayFilters={setDisplayFilters}
            filtersParams={filtersParams}
            setFiltersParams={setFiltersParams}
            defaultUserFilter={defaultUserFilter}
            userFilterCheck={userFilterCheck}
            reRenderUserFilter={reRenderUserFilter}
            resetFilters={resetFilters}
            setResetFiters={setResetFiters}
            list5WayFilter={list5WayFilter}
            setList5WayFilter={setList5WayFilter}
            onResetFilters={() => resetFiltersHandler() }
          />
          </FilterActions>
        </FlexCol>
      </FlexCol>
      <FlexCol className="grow w-full sm:w-[calc(100%-320px)]">
        <FlexCol className="w-full">
          <FlexRow className="h-fit pb-[16px] border-b justify-between items-center shrink-0">
            <FlexCol>
              <nav className="flex justify-between w-full" aria-label="Breadcrumb">
                <FlexCol className="grow">
                  <ol className="inline-flex items-center">
                    <li
                      className="inline-flex items-center"
                      aria-current="page"
                    >
                      <div className="inline-flex items-center space-x-2 text-base font-medium cursor-pointer">
                        <span>5Почему</span>
                      </div>
                    </li>
                  </ol>
                </FlexCol>
              </nav>
            </FlexCol>
          </FlexRow>
          <FlexCol className="pt-[16px] pb-[16px] gap-y-[16px]">
            <FlexRow className="gap-x-2.5">
              <FlexCol className="grow">
                <SearchUI
                  placeholder={
                    (type === FiveWhyType &&
                      "Ключевая фраза") ||
                    "Ключевая фраза"
                  }
                  defaultValue={searchQuery}
                  onClick={handleSearch}
                  inputClass="text-[13px] ml-px"
                />
              </FlexCol>
              <FlexCol className="shring-0">
                <FiltersButton
                  isSelectedFilters={isSelectedFilters}
                  onOpenFilters={() => { setIsOpenFilter(true); setReRenderUserFilter(Math.random()); }}
                />
              </FlexCol>
            </FlexRow>
            <FlexCol className="w-full h-[48px] tablet:w-auto">
              {(currentUser.isLocationEditorMyTasks ||
                currentUser.isAdmin ||
                currentUser.isLocationAdminMyTasks) && (
                  <Add5Way zIndex={70} type={type} />
                )}
            </FlexCol>
          </FlexCol>
          <FlexRow className="px-0 tablet:px-7.5">
            {(customLoading || statusUsers === "LOADING") && list5Way.length === 0 ? (
              <FlexCol className="w-full py-10 items-center justify-center gap-3">
                <Loading />
              </FlexCol>
            ) : (
              <MyTasksList5WayTable
                type={type}
                data={list5Way}
                setExportData={setExportData}
                customLoading={customLoading || statusUsers === "LOADING"}
                nextPage={nextPage}
              />
            )}
          </FlexRow>
        </FlexCol>
      </FlexCol>
    </FlexRow>
  );
}
